import * as React from "react";

interface IProps {
    componentName?: string;
}

interface IState {
    videoItem: {}
}

export class HomeWelcomeVideo extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            videoItem: {
                videoURL: 'https://www.youtube.com/watch?v=GHOwwbaF3v8',
                containment: '#home',
                autoPlay: true,
                showControls: false,
                showYTLogo: false,
                mute: true,
                startAt: 0,
                opacity: 1
            }
        }
    }

    public render() {
        return (
            <section
                id="home"
                className="home-section bg-dark-alfa-50"
                data-background="images/mobile-video-placeholder.jpg">

                <div className="js-height-full container">
                    <div
                        className="player"
                        data-property={JSON.stringify(this.state.videoItem)} />
                    <div className="home-content">
                        <div className="home-text">
                            <img src="asset/image/logo-md.png" alt="image" />
                            <h1 className="hs-line-11 no-transp font-alt">
                                Selamat Datang
                            </h1>
                            <h2 className="hs-line-12 font-alt mb-50 mb-xs-30 hidden">
                                <span>
                                    Desa Sanur Kauh
                                </span>
                            </h2>
                            <div className="local-scroll">
                                <div className="row">
                                    <div className="col-md-3">
                                        <a
                                            className="btn btn-block btn-mod btn-border-w btn-round hidden-xs btn-big-menu"
                                            href="http://gis.sanurkauh.desa.id">
                                            <span className="icon-map" />
                                            <br />
                                            GISAKA
                                        </a>
                                    </div>
                                    <div className="col-md-3">
                                        <a
                                            className="btn btn-block btn-mod btn-border-w btn-round hidden-xs btn-big-menu"
                                            href="/berita">
                                            <span className="icon-newspaper" />
                                            <br />
                                            BERITA TERBARU
                                        </a>
                                    </div>
                                    <div className="col-md-3">
                                        <a
                                            className="btn btn-block btn-mod btn-border-w btn-round hidden-xs btn-big-menu"
                                            href="/pengumuman">
                                            <span className="icon-megaphone" />
                                            <br />
                                            PENGUMUMAN
                                        </a>
                                    </div>
                                    <div className="col-md-3">
                                        <a
                                            className="btn btn-block btn-mod btn-border-w btn-round hidden-xs btn-big-menu"
                                            href="/aspirasi-pengaduan">
                                            <span className="icon-chat" />
                                            <br />
                                            PENGADUAN ONLINE
                                        </a>
                                    </div>
                                </div>
                        </div>
                    </div>
                    <div className="local-scroll" />
                </div>
                </div>

            </section>
        );
    }
}


// WEBPACK FOOTER //
// ./src/component/home/HomeWelcomeVideo.tsx